import { render } from "./Login.vue?vue&type=template&id=61af5b0a"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import exportComponent from "C:\\dev\\Lipa-Digital-Labs\\dev\\Potsmunter\\mpt-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__